import styled from "styled-components";

export const ButtonEl = styled.div`
   text-align: center;
   cursor: pointer;
   color: #999;
   padding: 0.5em;
   word-wrap: break-world;
`